import { PropsWithChildren, MouseEvent } from 'react'
import { HighlightTextWrapper } from 'components/HighlightTextWrapper'
import { cn } from '@wellesley/ui'
import { AppsLink, AppsRoutes } from '@wellesley/router'
import { RouteProps } from '@wellesley/router/types'
import { Params } from '@wellesley/router/getParams'

type ItemWrapperProps = {
  url?: AppsRoutes | ''
  props?: RouteProps
  queryParams?: Params
  onClick?: () => void
  searchQuery?: string
  className?: string
  dataTestId?: string
} & PropsWithChildren

export const ItemWrapper = ({
  children,
  url,
  props,
  queryParams,
  onClick,
  searchQuery,
  className,
  dataTestId,
}: ItemWrapperProps) => {
  const baseClassName = cn(
    'flex w-full cursor-pointer items-center gap-xxs rounded-m p-xxs text-base font-medium text-gray-900 hover:bg-gray-100 focus:bg-gray-100 focus:outline-none',
    className,
  )

  const handleLinkClick = onClick
    ? (e: MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault()
        e.stopPropagation()
        onClick()
      }
    : undefined

  if (url) {
    return (
      <HighlightTextWrapper searchText={searchQuery} dataTestId={dataTestId}>
        <AppsLink
          to={url}
          props={props}
          queryParams={queryParams}
          onClick={handleLinkClick}
          className={baseClassName}
        >
          {children}
        </AppsLink>
      </HighlightTextWrapper>
    )
  }

  return (
    <HighlightTextWrapper searchText={searchQuery} dataTestId={dataTestId}>
      <button type="button" onClick={onClick} className={baseClassName}>
        {children}
      </button>
    </HighlightTextWrapper>
  )
}
